import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { NoxoButton } from '@noxo/ui/button';
import { NoxoIcon } from '@noxo/ui/icon';

export type DemoCodeKind = 'message' | 'authenticator' | 'any';

@Component({
  selector: 'noxo-demo-code-hint',
  imports: [NoxoButton, NoxoIcon],
  template: `
    <noxo-icon icon="flask" />
    @if (showsMessage()) {
      @if (code(); as code) {
        <span
          >Demo code <strong>{{ code }}</strong></span
        >
        <button
          type="button"
          noxo-button="tertiary"
          size="xs"
          (click)="fill.emit(code)">
          Fill in
        </button>
      } @else {
        <span>Demo: an e-mailed or texted code shows up here as soon as it is sent.</span>
      }
    }
    @if (showsAuthenticator()) {
      <button
        type="button"
        noxo-button="tertiary"
        size="xs"
        (click)="fillAuthenticator.emit()">
        Fill in authenticator code
      </button>
    }
  `,
  styleUrl: './demo-code-hint.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoCodeHint {
  public readonly code = input<string>();
  public readonly kind = input<DemoCodeKind>('any');
  public readonly fill = output<string>();
  public readonly fillAuthenticator = output();

  protected readonly showsMessage = computed(() => this.kind() !== 'authenticator');
  protected readonly showsAuthenticator = computed(() => this.kind() !== 'message');
}
